import React from "react";

const RoleIcon = ({
  width = 44,
  height = 44,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1651_1785)">
        <rect x="2" y="1" width="40" height="40" rx="20" fill="white" />
        <rect
          x="2.5"
          y="1.5"
          width="39"
          height="39"
          rx="19.5"
          stroke="#E2E4E9"
        />
        <path
          d="M16 28.5C16 26.9087 16.6321 25.3826 17.7574 24.2574C18.8826 23.1321 20.4087 22.5 22 22.5C23.5913 22.5 25.1174 23.1321 26.2426 24.2574C27.3679 25.3826 28 26.9087 28 28.5H16ZM22.75 24.0623V27H26.2443C25.9761 26.2436 25.5109 25.5724 24.8966 25.056C24.2823 24.5395 23.5413 24.1964 22.75 24.0623ZM21.25 27V24.0623C20.4587 24.1964 19.7177 24.5395 19.1034 25.056C18.4891 25.5724 18.0239 26.2436 17.7558 27H21.25ZM22 21.75C19.5138 21.75 17.5 19.7362 17.5 17.25C17.5 14.7638 19.5138 12.75 22 12.75C24.4862 12.75 26.5 14.7638 26.5 17.25C26.5 19.7362 24.4862 21.75 22 21.75ZM22 20.25C23.6575 20.25 25 18.9075 25 17.25C25 15.5925 23.6575 14.25 22 14.25C20.3425 14.25 19 15.5925 19 17.25C19 18.9075 20.3425 20.25 22 20.25Z"
          fill="#525866"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1651_1785"
          x="0"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1651_1785"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1651_1785"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default RoleIcon;
